import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../../Icon/Icon.es.js';
import { Link } from '../../Link/Link.es.js';
import { ButtonCardCore } from '../ButtonCard.Core/ButtonCard.Core.es.js';

const ButtonCardLink = ({ className, children, disabled = false, hideArrow = false, variant, ...rest })=>{
    const linkProps = {
        ...rest,
        disabled
    };
    return jsx(ButtonCardCore, {
        className: className,
        disabled: disabled,
        variant: variant,
        children: jsxs(Link, {
            ...linkProps,
            children: [
                jsx("div", {
                    children: children
                }),
                !hideArrow && jsx(Icon, {
                    className: "arrow",
                    name: "ChevronRightOutline"
                })
            ]
        })
    });
};
ButtonCardLink.displayName = 'ButtonCard.Link';

export { ButtonCardLink as default };
//# sourceMappingURL=ButtonCard.Link.es.js.map
